var _rect, _defs, _style;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGradientBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: "100%",
    height: "100%",
    rx: 11.5,
    stroke: "url(#paint0_linear_146_1725)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_1725",
    x1: 0,
    y1: 0,
    x2: 158.424,
    y2: 406.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n#rect-outline {\n  width: calc(100% - 1px);\n  height: calc(100% - 1px);\n}\n")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBorder);
export default __webpack_public_path__ + "static/media/gradientBorder.df10c4726294bdc28618c275ba63af2f.svg";
export { ForwardRef as ReactComponent };